import { render } from "./ParticlesComponent.vue?vue&type=template&id=6ae7c5c7&scoped=true"
import script from "./ParticlesComponent.vue?vue&type=script&lang=js"
export * from "./ParticlesComponent.vue?vue&type=script&lang=js"

import "./ParticlesComponent.vue?vue&type=style&index=0&id=6ae7c5c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae7c5c7"]])

export default __exports__